<template>
<div class="tool-area-admin">

  <div v-if="!isMobile">
  <div @click="goTurn('/knowledge/law')" class="default-btn default-btn-hover" :class="{
    'default-btn-hove-active': $route.path=='/knowledge/law'
  }">
    <img :src="law_icon" alt="" class="btn_icon" />
    <div class="btn_text">法律法规</div>
  </div>

  <div @click="goTurn('/knowledge/typicalCases')" class="default-btn default-btn-hover" :class="{
    'default-btn-hove-active': $route.path=='/knowledge/typicalCases'
  }">
      <img :src="case_icon" alt="" class="btn_icon" />
      <div class="btn_text">典型案例</div>
  </div>

  <div v-if="isLogin" @click="goTurn('/knowledge/collect')" class="default-btn default-btn-hover" :class="{
    'default-btn-hove-active': $route.path=='/knowledge/collect'
  }">
    <img :src="collect_icon" alt="" class="btn_icon" />
    <div class="btn_text">我的收藏</div>
  </div>
  </div>

  <div style="width: 32px;margin-left: 6px;" v-else>
    <div class="btn-div-img" @click="onChange">
      <img :src="navExpand" alt="" class="nav-fold" />
    </div>
    <div class="btn-div-img" @click="goTurn('/knowledge/law')">
      <img :src="law_icon" alt="" class="nav-fold" />
    </div>
    <div class="btn-div-img" @click="goTurn('/knowledge/typicalCases')">
      <img :src="case_icon" alt="" class="nav-fold" />
    </div>
    <div v-if="isLogin" class="btn-div-img" @click="goTurn('/knowledge/collect')">
      <img :src="collect_icon" alt="" class="nav-fold" />
    </div>
  </div>
</div>
</template>

<script>
import law_icon from '@/assets/law_icon.png'
import collect_icon from '@/assets/collect_icon.png'
import navExpand from '@/assets/nav-expand.png'
import case_icon from '@/assets/case_icon.svg'
import {mapMutations, mapState} from 'vuex'
export default {
  name: "knowledgeTool",
  computed: {
    ...mapState('mobile', ['isMobile']),
    ...mapState('channel', ['isLogin']),
  },
  data(){
    return {
      law_icon,
      case_icon,
      collect_icon,
      navExpand
    }
  },
  mounted(){
    this.$nextTick(() => {
      document.getElementById('left-menu').style.background = '#fff'
    })
  },
  methods:{
    ...mapMutations('mobile',['setMobile']),
    onChange(){
      this.setMobile(false)
    },
    goTurn(path){
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="scss">
.btn-div-img{
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 20px;
  .nav-fold{
    width: 20px;
    height: 20px;
  }
}
.btn-div-img:hover{
  background: rgba(1,10,28,0.05);
  border-radius: 4px;
}

.tool-area-admin{
  padding: 20px 0;
}
.default-btn{
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  margin-bottom: 12px;
}
.default-btn-hover:hover{
  background: rgba(1,10,28,0.05);
  border-radius: 8px;
  .expand_icon{
    display: block !important;
  }
}
.default-btn-hove-active{
  background: rgba(1,10,28,0.05);
  border-radius: 8px;
}
.btn_icon{
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.btn_text{
  font-size: 14px;
  color: rgba(0,0,0,0.85);
  line-height: 20px;
  flex: 1;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
}
.default-btn-hove-active{
  background: rgba(1,10,28,0.05);
  border-radius: 8px;
}
</style>